export default {"src":"/_next/static/media/icon_elite.e0532d22.svg","height":560,"width":560,"blurWidth":0,"blurHeight":0};